export enum CourseType {
  ITEM = 'ITEM',
  STARTING_SITUATION = 'STARTING_SITUATION',
}
